'use client'

import { useRouter } from 'next/navigation'

import { UserType } from '@/entities/user'
import { Button, Icon } from '@/shared/ui'

type Props = {
  userType: UserType
  chatRoomUrl: string
}

export const ChatButton = ({ userType, chatRoomUrl }: Props) => {
  const router = useRouter()

  const handleClick = () => {
    router.push(chatRoomUrl)
  }

  return (
    <Button
      variant="outline"
      size="medium"
      color="primary"
      shape="pill"
      fullWidth
      onClick={handleClick}
      className="gap-2"
    >
      <Icon name="message" size={16} />
      {userType === UserType.GUEST ? '호스트와 채팅하기' : '게스트와 채팅하기'}
    </Button>
  )
}
